import e from "../../../calendar-carburettor/converter/look-up.js";
import "../../constants/calendar-date.js";
import { previous_month as t } from "./previous_month.js";
import { previous_year as n } from "./previous_year.js";
// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/previous_month_days.ts
var r = (r) => n(r) >= 1970 ? e.queryDays(n(r), t(r)) : 30;
export { r as previous_month_days };

//# sourceMappingURL=previous_month_days.js.map